export default __webpack_public_path__ + "static/dBDwphrw-afae1e415fcc4e45f6d7b8950cc9cdce.svg";